import { Link } from "react-router";
import { useAppContext } from "@/providers";
import { t } from "@/lib/i18n/messages";
import { Logo } from "@/components/layout/logo";
import { Button } from "@/components/ui/button";
import { AccountMenu } from "@/components/layout/account-menu";

export function SiteHeader() {
  const { locale, setLocale, session } = useAppContext();

  const toggleLocale = () => setLocale(locale === "ar" ? "en" : "ar");

  return (
    <header className="fixed top-0 w-full z-50 bg-card/80 backdrop-blur-md border-b border-border transition-colors duration-slow">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Logo />
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-foreground-secondary">
            <Link className="hover:text-primary transition-colors duration-base" to="#">
              {t(locale, "home")}
            </Link>
            <Link className="hover:text-primary transition-colors duration-base" to="#">
              {t(locale, "about")}
            </Link>
            <Link className="hover:text-primary transition-colors duration-base" to="#">
              {t(locale, "initiatives")}
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={toggleLocale}
            className="flex items-center gap-1 text-sm font-medium text-foreground-secondary hover:text-foreground transition-colors duration-base px-2 py-1 rounded-lg hover:bg-muted"
          >
            <span>{locale === "ar" ? "EN" : "عربي"}</span>
          </button>
          {!session.isAuthenticated ? (
            <Link to="/login">
              <Button variant="outline" size="sm">
                {t(locale, "login")}
              </Button>
            </Link>
          ) : null}
          <AccountMenu />
        </div>
      </div>
    </header>
  );
}
